import { render, staticRenderFns } from "./RecordListItem.vue?vue&type=template&id=f369484e&"
import script from "./RecordListItem.vue?vue&type=script&lang=js&"
export * from "./RecordListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports